export default "__VITE_ASSET__iwp3iKM___"